// extracted by mini-css-extract-plugin
export default {"container":"seatUpgrade_container__tsuK5"};